import { render, staticRenderFns } from "./FloorPlanCreation.vue?vue&type=template&id=20b70b5d"
import script from "./FloorPlanCreation.vue?vue&type=script&lang=js"
export * from "./FloorPlanCreation.vue?vue&type=script&lang=js"
import style0 from "./FloorPlanCreation.vue?vue&type=style&index=0&id=20b70b5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports